// GENERATED by scripts/sync-live-assets.sh - do not edit.
/* eslint-disable @typescript-eslint/no-require-imports */
export interface LiveAssets {
  loop: number;
  mouthTrack?: unknown;
  visemeMeta?: unknown;
  crops?: Record<string, number>;
  alphaWebm?: number; // pre-keyed full-res loop (VP9 alpha): no per-frame chroma key
  alphaMov?: number; // same, HEVC alpha for Safari/iOS
  poster?: number; // keyed first frame of the talk loop (shown until the loop draws)
}
export const LIVE_ASSETS: Record<string, LiveAssets> = {
  clio: {
    loop: require('../../assets/v10/deities/live/clio/loop.mp4'),
    mouthTrack: require('../../assets/v10/deities/live/clio/mouth_track.json'),
    visemeMeta: require('../../assets/v10/deities/live/clio/visemes.json'),
    crops: {
      AA: require('../../assets/v10/deities/live/clio/crop_AA.png'),
      AH_open: require('../../assets/v10/deities/live/clio/crop_AH_open.png'),
      EE: require('../../assets/v10/deities/live/clio/crop_EE.png'),
      FF: require('../../assets/v10/deities/live/clio/crop_FF.png'),
      LL: require('../../assets/v10/deities/live/clio/crop_LL.png'),
      MM: require('../../assets/v10/deities/live/clio/crop_MM.png'),
      OH: require('../../assets/v10/deities/live/clio/crop_OH.png'),
      OO: require('../../assets/v10/deities/live/clio/crop_OO.png'),
      TH: require('../../assets/v10/deities/live/clio/crop_TH.png'),
      sil: require('../../assets/v10/deities/live/clio/crop_sil.png'),
    },
  },
  syqi: {
    loop: require('../../assets/v10/deities/live/syqi/loop.mp4'),
    alphaWebm: require('../../assets/v10/deities/live/syqi/talk.webm'),
    alphaMov: require('../../assets/v10/deities/live/syqi/talk.mov'),
    poster: require('../../assets/v10/deities/live/syqi/talk_poster.png'),
    mouthTrack: require('../../assets/v10/deities/live/syqi/mouth_track.json'),
    visemeMeta: require('../../assets/v10/deities/live/syqi/visemes.json'),
    crops: {
      AA: require('../../assets/v10/deities/live/syqi/crop_AA.png'),
      AH_open: require('../../assets/v10/deities/live/syqi/crop_AH_open.png'),
      CH: require('../../assets/v10/deities/live/syqi/crop_CH.png'),
      DD: require('../../assets/v10/deities/live/syqi/crop_DD.png'),
      EE: require('../../assets/v10/deities/live/syqi/crop_EE.png'),
      EH: require('../../assets/v10/deities/live/syqi/crop_EH.png'),
      FF: require('../../assets/v10/deities/live/syqi/crop_FF.png'),
      IH: require('../../assets/v10/deities/live/syqi/crop_IH.png'),
      KK: require('../../assets/v10/deities/live/syqi/crop_KK.png'),
      LL: require('../../assets/v10/deities/live/syqi/crop_LL.png'),
      MM: require('../../assets/v10/deities/live/syqi/crop_MM.png'),
      NN: require('../../assets/v10/deities/live/syqi/crop_NN.png'),
      OH: require('../../assets/v10/deities/live/syqi/crop_OH.png'),
      OO: require('../../assets/v10/deities/live/syqi/crop_OO.png'),
      RR: require('../../assets/v10/deities/live/syqi/crop_RR.png'),
      SS: require('../../assets/v10/deities/live/syqi/crop_SS.png'),
      TH: require('../../assets/v10/deities/live/syqi/crop_TH.png'),
      sil: require('../../assets/v10/deities/live/syqi/crop_sil.png'),
    },
  },
};
